export default __webpack_public_path__ + "static/media/pictogramBeaconPayIn128.98840303.svg";